export const PHONE_REGEX = new RegExp(/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/);
export const POSTALCODE_REGEX = new RegExp(/^(([0-8][0-9])|(9[0-8])|(2[ab]))[0-9]{3}$/, 'i');
export const FORBIDDEN_CHARS_REGEX = new RegExp(/^[^\/&"<>]*$/, 'i');
export const SIREN_REGEX = new RegExp(/^\d{9}$/);
